import { PerformanceReportService } from 'src/app/services/report/performance-report.service';
import DateUtils from 'src/app/utils/date';
import { DealModel } from 'src/app/models/deal.model';
import { Component, OnInit } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexPlotOptions, ApexXAxis
} from "ng-apexcharts";
import { DealsService } from 'src/app/services/deals.service';
import { map } from 'rxjs/operators';
import { DealPipelineWorkflowService } from 'src/app/services/settings-services/deal-pipeline-workflow.service';
import { Observable } from 'rxjs';
import { StringMapWithRename } from '@angular/compiler/src/compiler_facade_interface';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  colors: string[]
};
@Component({
  selector: 'app-deal-lost-graph',
  templateUrl: './deal-lost-graph.component.html',
  styleUrls: ['./deal-lost-graph.component.css']
})
export class DealLostGraphComponent implements OnInit {
  dateUtil = new DateUtils;
  monthList = ['Jan', 'Feb', 'March', 'April', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
  public chartOptions = {
    series: [
      {
        name: "reason",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      }
    ],
    chart: {
      type: "bar",
      height: 300
    },
    plotOptions: {
      bar: {
        horizontal: false,
        distributed: true,
        // columnWidth: '30%',
      }
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      title: {
        text: 'Months',
      },
      categories: ['Jan', 'Feb', 'March', 'April', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
    },
    yaxis: {
      title: {
        text: 'Count',
      },
      labels: {
        formatter: function (value) {
          return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(value)
        }
      },
    },
    colors: ["#DC3545"]
  };
  years: any[];
  selectedYr = new Date().getFullYear();
  selectedPeriod = 'monthly'
  allReasonList$: Observable<any[]>;
  months = { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0 };
  selectedReason = 'All';
  selectedIds: any[] = null;
  selectedType: string;
  result;
  dealsData: any[]
  constructor(
    private dealSrv: DealsService,
    private performRepSrv: PerformanceReportService,
    private dealworkflowSrv: DealPipelineWorkflowService) {
    this.years = this.dateUtil.getYears();
    this.allReasonList$ = (this.dealworkflowSrv.fetchDealReasons() as any);

  }


  ngOnInit() { 
    this.performRepSrv.selected_users.subscribe(res => {
      if (res && res.type) {
        const { ids, type } = res;
        this.selectedType = type;
        this.selectedIds = ids;
      }
      this.getData();
    })
  }
  dateChange({ selectedPeriod, selectedYr }) {
    this.selectedYr = selectedYr;
    this.selectedPeriod = selectedPeriod;
    this.getData();
  }

  getData() {
    this.resetGraph();
    const dateFilter = this.dateUtil.getYearToDateRange(this.selectedYr);
    let filter: any = { dateFilter, status: 'LOST', dateToFilterBy: 'actualClosedDate'};
    
    if (this.selectedType === 'salesperson') {
      filter = { ...filter, salesPerson: { ids: this.selectedIds } }
    }
    this.dealSrv.fetchDeals(this.selectedIds, filter).pipe(map((resp: any[]) => {
      let result = resp;
      if (this.selectedReason !== 'All') {
        result = resp.filter(res => res.comment === this.selectedReason);
      }
      return result;
    })).subscribe((res: any[]) => {
      this.dealsData = res;      
      this.formulateData(res);
    })
  }
  formulateData(datas: DealModel[]) {
    datas.forEach(data => {
      if(!(data.actualClosedDate)) return;
      const month = new Date(data.actualClosedDate).getMonth();
      this.updateMonth(month);
    })
    if (this.selectedPeriod === 'quaterly') {
      const { quatersLabel, quarters } = this.dateUtil.getQuarterlyData(this.months);
      this.chartOptions.xaxis.categories = quatersLabel
      this.chartOptions.series[0].data = quarters;
      this.result = quarters
    } else {
      const result = [];
      Object.values(this.months).forEach(v => result.push(v))
      this.result = result;
      this.chartOptions.series[0].data = this.result;
      this.chartOptions.xaxis.categories = this.monthList;
    }
  }
  updateMonth(mnth) {
    let count = this.months[mnth];
    if (count || count === 0) {
      count = count + 1
    }
    this.months[mnth] = count;
  }


  resetGraph() {
    this.result = null;
    this.months = {
      0: 0, 1: 0, 2: 0,
      3: 0, 4: 0, 5: 0,
      6: 0, 7: 0, 8: 0,
      9: 0, 10: 0, 11: 0
    };
  }


}
